<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title ">Entrance Test Syllabus For Session 2025-26</h4>
                    <div class="card-body text-justify">
                        <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Class</th>
                                <th scope="col" class="text-center">Download</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- <tr>
                                <th scope="row">1</th>
                                <td>KG</td>
                                <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/19ZJapmRzCo65rtCNtlxJn6aC54WcLUfz/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
                              </tr> -->
                              <tr>
                                <th scope="row">1</th>
                                <td>LKG</td>
                                <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1aCeyLJGWLmCgpB_mwM7yxkiDoZJc-b_p/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">2</th>
                                <td>UKG</td>
                                <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/16Lo9ZkQf-3H6e_Ed26zDxntr45hyaWHc/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">1</th>
                                <td>I</td>
                                <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/17897Q-SNs7HGwnLKIz2ddz-zPwd4bnDV/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <!-- <tr>
                                <th scope="row">4</th>
                                <td>II</td>
                                <td class="text-center"><a target="_blank" href="" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">5</th>
                                <td>Class III</td>
                                <td class="text-center"><a target="_blank" href="" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">6</th>
                                <td>Class IV</td>
                                <td class="text-center"><a target="_blank" href="" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">7</th>
                                <td>Class V</td>
                                <td class="text-center"><a target="_blank" href="" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">8</th>
                                <td>Class VI</td>
                                <td class="text-center"><a target="_blank" href="" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">9</th>
                                <td>Class VII</td>
                                <td class="text-center"><a target="_blank" href="" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">10</th>
                                <td>Class VIII</td>
                                <td class="text-center"><a target="_blank" href="" ><i class="fas fa-download"></i></a></td>
                              </tr> -->
                              <tr>
                                <th scope="row">2</th>
                                <td>Class XI</td>
                                <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/12t7cIPYPvbymVXlKeFUqfW_N5ia7Afbg/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
                              </tr>
                              <tr>
                                <th scope="row">3</th>
                                <td>Class XI-Arts</td>
                                <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1gIf3FVAOKBY-Nb9QpLz2_dPXn8bhbEm-/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
                              </tr>
                            </tbody>
                          </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <tr>
  <th scope="row">1</th>
  <td>LKG</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1-RDtOzRZTDtIr1n1On1UVu4L4qP8OuYB/view?usp=share_link" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">2</th>
  <td>UKG</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1iHFZNzDpfnEnclxMYnB3AxW0lzNp8yN8/view?usp=share_link" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">3</th>
  <td>I</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/17897Q-SNs7HGwnLKIz2ddz-zPwd4bnDV/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">4</th>
  <td>II</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1gdlkfLBJgfg8d3mgy2RDCi4NE9_GSYY2/view?usp=share_link" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">5</th>
  <td>Class III</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1d9e0k-3WW0NmToFqD8fxBpPQpS2X54LR/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">6</th>
  <td>Class IV</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1vxQ87jUKi0MHVxEEfNR3Da6ckJGUEyEq/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">7</th>
  <td>Class V</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/18vcJcy4iopctiIaRLbE49xHhRMC6wk_7/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">8</th>
  <td>Class VI</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1HjLZiT_EnD3i9iExDp9YoYAVYc_wISzl/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">9</th>
  <td>Class VII</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1UoHnIq7xKowyQ18Gl4PTE2xh8YP6RrKE/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">10</th>
  <td>Class VIII</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1N2KPS37sHVX9AvzlUFX-8eShl6ZpVYPP/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">11</th>
  <td>Class XI</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/12t7cIPYPvbymVXlKeFUqfW_N5ia7Afbg/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr>
<tr>
  <th scope="row">12</th>
  <td>Class XI-Arts</td>
  <td class="text-center"><a target="_blank" href="https://drive.google.com/file/d/1gIf3FVAOKBY-Nb9QpLz2_dPXn8bhbEm-/view?usp=sharing" ><i class="fas fa-download"></i></a></td>
</tr> -->